/*jshint esversion: 11 */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input,
  Alert
} from 'reactstrap';
import Select from 'react-select';
import PageDataLoader from '../Utility/PageDataLoader';

import { createCircular } from '../../api/circular';
import { getTagList } from '../../api/tag';
import { getBatchList } from '../../api/batch';
import { AvField, AvForm } from 'availity-reactstrap-validation';

const CreateCircularModal = ({
  modalOpenState,
  closeModalHandler,
  refreshList,
  setSuccessAlert,
  showErrorAlert,
  resetErrorAlert
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [description, setDescription] = useState('');
  const [tagOptions, setTagOptions] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);

  const [selectedTag, setSelectedTag] = useState(null);
  const [selectedBatches, setSelectedBatches] = useState([]);

  const [files, setFiles] = useState([]);

  const buildOptions = (list) =>
    list.map((item) => ({
      value: item._id,
      label: item.name
    }));

  useEffect(() => {
    async function fetchOptions() {
      const tagRes = await getTagList(1, 100);
      if (tagRes) setTagOptions(buildOptions(tagRes?.data || []));

      const batchRes = await getBatchList(1, 100);
      if (batchRes) setBatchOptions(buildOptions(batchRes?.data || []));
    }

    fetchOptions();
  }, []);

  const handleFileChange = (e) => {
    setError('');

    const selected = Array.from(e.target.files);

    const invalidFiles = selected.filter(
      (file) =>
        file.type !== 'application/pdf' &&
        !file.name.toLowerCase().endsWith('.pdf')
    );

    if (invalidFiles.length > 0) {
      setError('Only PDF files are allowed');
      e.target.value = null;
      return;
    }

    setFiles((prev) => [...prev, ...selected]);

    e.target.value = null;
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    setError('');
    resetErrorAlert();

    if (!selectedTag) return setError('Tag required');
    if (!selectedBatches.length) return setError('Batch required');
    if (!files.length) return setError('File required');

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append('description', description);
      formData.append('tag', selectedTag.value);
      selectedBatches.forEach((b) => {
        formData.append('batches', b.value);
      });
      formData.append('draft', 'false');

      files.forEach((file) => {
        formData.append('files', file);
      });

      const res = await createCircular(formData);

      if (!res?.response) {
        setError(res?.error || 'Create failed');
        return;
      }

      refreshList && refreshList();
      setSuccessAlert(`Circular Created successfully`);
      setSelectedTag(null);
      setSelectedBatches([]);
      setFiles([]);
      closeModalHandler();
    } catch (e) {
      showErrorAlert(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={modalOpenState} backdrop="static" size="lg">
      <ModalHeader toggle={closeModalHandler}>Create Circular</ModalHeader>

      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}
        <AvForm>
          <Row>
            <Col md="12">
              <FormGroup>
                <Label>Description</Label>

                <AvField
                  name="description"
                  placeholder="Enter Circular Description ..."
                  type="text"
                  className="form-control"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: 'Description is required'
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label>Tag</Label>
                <Select
                  options={tagOptions}
                  value={selectedTag}
                  onChange={setSelectedTag}
                />
              </FormGroup>
            </Col>

            <Col md="12">
              <FormGroup>
                <Label>Batches</Label>
                <Select
                  options={batchOptions}
                  isMulti
                  value={selectedBatches}
                  onChange={setSelectedBatches}
                />
              </FormGroup>
            </Col>

            <Col md="12">
              <FormGroup>
                <Label>Files</Label>

                {files.map((f, i) => (
                  <div key={i} className="d-flex mb-2">
                    <Input value={f.name} readOnly />
                    <Button
                      color="danger"
                      size="sm"
                      className="ml-2"
                      onClick={() => handleRemoveFile(i)}
                    >
                      Remove
                    </Button>
                  </div>
                ))}

                <Input
                  type="file"
                  multiple
                  accept=".pdf,application/pdf"
                  onChange={handleFileChange}
                />
              </FormGroup>
            </Col>
          </Row>
        </AvForm>
      </ModalBody>

      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Creating...' : 'Create'}
        </Button>

        <Button color="light" onClick={closeModalHandler}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateCircularModal;
